import { Profile, compareProfilesByScore } from 'features/profiles/useProfiles';
import { getFirstPartOfEmail } from 'shared/lib/email';

/** Shared profile-selector sort — keeps dropdown order and ←/→ cycling in sync. */
export type ProfileSearchSort = 'score' | 'last updated';

let currentSort: ProfileSearchSort = 'score';
const listeners = new Set<() => void>();

export const getProfileSearchSort = (): ProfileSearchSort => currentSort;

export const setProfileSearchSort = (sort: ProfileSearchSort): void => {
  if (currentSort === sort) return;
  currentSort = sort;
  listeners.forEach((listener) => listener());
};

export const subscribeProfileSearchSort = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Profile ids in the active selector sort order (for ←/→ cycling). */
export const profileIdsForSearchSort = (
  profiles: Iterable<Profile>,
  sortBy: ProfileSearchSort = currentSort,
  /** When provided and sort is score, skip re-sorting the full roster. */
  rankedProfiles?: readonly Profile[]
): string[] => {
  if (sortBy === 'score' && rankedProfiles) {
    return rankedProfiles.map((profile) => getFirstPartOfEmail(profile.email));
  }
  const list = Array.from(profiles);
  if (sortBy === 'last updated') {
    list.sort((a, b) => b.lastActivityAt.getTime() - a.lastActivityAt.getTime());
  } else {
    list.sort(compareProfilesByScore);
  }
  return list.map((profile) => getFirstPartOfEmail(profile.email));
};
